import { isPhone, isWeb } from '@helpers';
import { useHandleNavigationMachinesHeader } from './useHandleNavigationMachineHeader';

export const useBackgroundColor = () => {
  const { shouldUseSystemBackgroundOnPhone, isMachinesScreen } = useHandleNavigationMachinesHeader();

  const machineScreenMainBg =
    isPhone && shouldUseSystemBackgroundOnPhone
      ? 'Background/Light/System'
      : isWeb || isMachinesScreen
      ? 'Background/Light/Detail'
      : 'Background/Light/Panel';

  return { machineScreenMainBg };
};
